<template>
  <v-container id="calculator-wrapper">
    <div class="hero-image hero-image1">
      <div class="hero-text">
        <h1 class="mb-4 heading">
            Calculate Monthly Earnings
          </h1>
          <h4 class="subheading">
            Hygiene Calculator
          </h4>
          <h4 class="subheading">
            Double Hygiene
          </h4>
      </div>
    </div>
    <v-container class="calculator-container">
      <v-row>
        <v-col class="input-column">
          <v-container>
            <v-row>
              <v-col class="section-header text-center header-text">INPUTS</v-col>
            </v-row>
            <v-row>
              <v-col class="section-header header-text">Lead Hygienist</v-col>
            </v-row>
            <v-row class="column-labels">
              <v-col></v-col>
              <v-col md="2" class="col-input">Scenario 1</v-col>
              <v-col md="2" class="col-input">Scenario 2</v-col>
            </v-row>
          </v-container>
          <v-row align="center" justify="center" class="calculator-row"><!--Production Per Day-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Production Per Day</span>
                </template>
                <span  v-html="this.tipProductionPerDay"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtProductionPerDayCurrent"
                  placeholder=""
                  type="text"
                  @input="updateFields"
                  filled
                  rounded
                  style="height: 30px; border-radius:10px;"
                  reverse
                  class="text-blue number-input"
                  hide-spin-buttons
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtProductionPerDayCalculated"
                  placeholder=""
                  type="text"
                  @input="updateFields"
                  filled
                  rounded
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!--Hourly Rate-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Hourly Rate</span>
                </template>
                <span v-html="this.tipHourlyRate"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtHourlyRateCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtHourlyRateCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!-- Hours Worked Per Day-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Hours Worked Per Day</span>
                </template>
                <span v-html="this.tipHoursWorkedPerDay"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">&nbsp;</div>
              <v-text-field
                  v-model="txtHoursWorkedPerDayCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">&nbsp;</div>
              <v-text-field
                  v-model="txtHoursWorkedPerDayCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!-- Days Worked Per Week -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Days Worked Per Week</span>
                </template>
                <span v-html="this.tipDaysWorkedPerWeek"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">&nbsp;</div>
              <v-text-field
                  v-model="txtDaysWorkedPerWeekCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">&nbsp;</div>
              <v-text-field
                  v-model="txtDaysWorkedPerWeekCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-container>
            <v-row>
              <v-col class="section-header header-text">Associate Hygienist</v-col>
            </v-row>
            <v-row class="column-labels">
              <v-col></v-col>
              <v-col md="2" class="col-input">Scenario 1</v-col>
              <v-col md="2" class="col-input">Scenario 2</v-col>
            </v-row>
          </v-container>
          <v-row align="center" justify="center" class="calculator-row"><!--Associate Production per Day-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Production per Day</span>
                </template>
                <span v-html="this.tipProductionPerDay"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtProductionPerDayAssociateCurrent"
                  placeholder=""
                  type="text"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtProductionPerDayAssociateCalculated"
                  placeholder=""
                  type="text"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!--Associate Hourly Rate-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Hourly Rate</span>
                </template>
                <span v-html="this.tipHourlyRate"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtHourlyRateAssociateCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtHourlyRateAssociateCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!--Associate Hours Worked Per Day-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Hours Worked Per Day</span>
                </template>
                <span v-html="this.tipHoursWorkedPerDay"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtHoursWorkedPerDayAssociateCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtHoursWorkedPerDayAssociateCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!--Associate Days Worked Per Week-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Days Worked Per Week</span>
                </template>
                <span v-html="this.tipDaysWorkedPerWeek"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtDaysWorkedPerWeekAssociateCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtDaysWorkedPerWeekAssociateCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col  class="blueBackground results-column">
          <v-container>
            <v-row>
              <v-col class="section-header text-center header-text">MONTHLY HYGIENIST PERFORMANCE</v-col>
            </v-row>
            <v-row class="column-labels">
              <v-col></v-col>
              <v-col md="2" class="col-input">Scenario 1</v-col>
              <v-col md="2" class="col-input">Scenario 2</v-col>
            </v-row>
          </v-container>
          <v-row align="center" justify="center" class="calculator-row"> <!--Hygiene Revenue -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Hygiene Revenue</span>
                </template>
                <span v-html="this.tipHygieneRevenue"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultHygieneRevenueCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultHygieneRevenueCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!-- Hygiene Supplies -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Hygiene Supplies</span>
                </template>
                <span v-html="this.tipHygieneSupplies"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultHygieneSuppliesCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultHygieneSuppliesCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!-- Associate Wages -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Associate Wages</span>
                </template>
                <span v-html="this.tipAssociateWages"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultAssociateWagesCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultAssociateWagesCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="blueBackgroundHighlight"><!-- Lead Gross Profit -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  > Lead Gross Profit</span>
                </template>
                <span v-html="this.tipGrossProfit"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultGrossProfitCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultGrossProfitCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row results-section-header"><!-- Lead Profit Sharing -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Lead Profit Sharing</span>
                </template>
                <span v-html="this.tipProfitSharing"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="resultProfitSharingCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input percent-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="resultProfitSharingCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input percent-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row blueBackgroundHighlight"><!-- Total Eligible Lead Profit Sharing -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Total Eligible Lead Profit Sharing</span>
                </template>
                <span v-html="this.tipEligibleProfitSharing"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultEligibleProfitSharingCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultEligibleProfitSharingCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!-- Lead Monthly Wages Paid -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Lead Monthly Wages Paid</span>
                </template>
                <span v-html="this.tipLeadWages"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultLeadWagesCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultLeadWagesCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class=" darkBlueBackground "> <!-- Lead Earned Monthly Incentive -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  >Lead Earned Monthly Incentive</span>
                </template>
                <span v-html="this.tipHygienistEarnedIncentive"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultLeadEarnedIncentiveCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultLeadEarnedIncentiveCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="last-line darkBlueBackground"> <!--Lead Effective Hourly Rate -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  >Lead Effective Hourly Rate</span>
                </template>
                <span v-html="this.tipLeadHourlyRateWithIncentive"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultLeadHourlyRateWithIncentiveCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultLeadHourlyRateWithIncentiveCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="last-line darkBlueBackground"> <!--  Total Lead Annual Earnings -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  > Total Lead Annual Earnings</span>
                </template>
                <span v-html="this.tipTotalHygienestEarnings"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultTotalHygienistEarningsCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultTotalHygienistEarningsCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>


          <v-row align="center" justify="center" class="calculator-row results-section-header"> <!-- Associate Revenue -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  >Associate Revenue</span>
                </template>
                <span v-html="this.tipAssociateRevenue"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultAssociateRevenueCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultAssociateRevenueCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!-- Associate Profit Sharing -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  >Associate Profit Sharing</span>
                </template>
                <span v-html="this.tipAssocaiteProfitSharing"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="resultAssociateProfitSharingCurrent"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input percent-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="resultAssociateProfitSharingCalculated"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input percent-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row darkBlueBackground"> <!-- Associate Earned Monthly Incentive -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  >Associate Earned Monthly Incentive</span>
                </template>
                <span v-html="this.tipAssociateEarnedIncentive"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultAssociateEarnedIncentiveCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultAssociateEarnedIncentiveCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row darkBlueBackground"> <!-- Associate Effective Hourly Rate -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  >Associate Effective Hourly Rate</span>
                </template>
                <span v-html="this.tipAssociateHourlyRateWithIncentive"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultAssociateHourlyRateWithIncentiveCurrent"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultAssociateHourlyRateWithIncentiveCalculated"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="last-line darkBlueBackground"> <!-- Total Associate Annual Earnings -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  >Total Associate Annual Earnings</span>
                </template>
                <span v-html="this.tipTotalAssociateEarings"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultAssociateTotalEarningsCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultAssociateTotalEarningsCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>




          <v-row class="instructions-row">
            <v-col class= "instructions-right disclaimer">Hygiene supply costs may vary month to month. Example above reflective of supplies equal to 6.6% of hygiene revenue.</v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>
<style scoped>
.number-input >>> input[type="number"] {
  -moz-appearance: textfield;
}
.number-input >>> input::-webkit-outer-spin-button,
.number-input >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
<script>
  import html2canvas from 'html2canvas';
  export default {
    name: 'Calculator',
    methods: {
      updateFields (){
        this.numProductionPerDayCurrent = this.txtProductionPerDayCurrent.toString().replaceAll(',', '');
        this.numProductionPerDayCalculated = this.txtProductionPerDayCalculated.toString().replaceAll(',', '');
        this.numProductionPerDayAssociateCurrent = this.txtProductionPerDayAssociateCurrent.toString().replaceAll(',', '');
        this.numProductionPerDayAssociateCalculated = this.txtProductionPerDayAssociateCalculated.toString().replaceAll(',', '');
        /*Calculate Incremental Inputs */
        this.txtProductionPerDayIncremental = this.numProductionPerDayCalculated - this.numProductionPerDayCurrent;
        this.txtHourlyRateIncremental = parseFloat(this.txtHourlyRateCalculated) - parseFloat(this.txtHourlyRateCurrent);
        this.txtHoursWorkedPerDayIncremental = this.txtHoursWorkedPerDayCalculated - this.txtHoursWorkedPerDayCurrent;
        this.txtDaysWorkedPerWeekIncremental = this.txtDaysWorkedPerWeekCalculated - this.txtDaysWorkedPerWeekCurrent;
        this.txtPatientLoyaltyScoreIncremental = this.txtPatientLoyaltyScoreCalculated - this.txtPatientLoyaltyScoreCurrent;
        /*Calculate results*/

        /*Hygiene Revenue*/
        this.resultHygieneRevenueCurrent = (this.numProductionPerDayCurrent * this.txtDaysWorkedPerWeekCurrent *4.4) + (this.numProductionPerDayAssociateCurrent * this.txtDaysWorkedPerWeekAssociateCurrent * 4.4);
        this.resultHygieneRevenueCalculated = (this.numProductionPerDayCalculated * this.txtDaysWorkedPerWeekCalculated *4.4) + (this.numProductionPerDayAssociateCalculated * this.txtDaysWorkedPerWeekAssociateCalculated * 4.4);
        /*Hygiene Supplies*/
        this.resultHygieneSuppliesCurrent = this.resultHygieneRevenueCurrent * .066;
        this.resultHygieneSuppliesCalculated = this.resultHygieneRevenueCalculated * .066;
        /*Associate Wages*/
        this.resultAssociateWagesCurrent = this.txtHourlyRateAssociateCurrent * this.txtHoursWorkedPerDayAssociateCurrent * this.txtDaysWorkedPerWeekAssociateCurrent * 4.4;
        this.resultAssociateWagesCalculated = this.txtHourlyRateAssociateCalculated * this.txtHoursWorkedPerDayAssociateCalculated * this.txtDaysWorkedPerWeekAssociateCalculated * 4.4;
        /*Gross Porfit*/
        this.resultGrossProfitCurrent = this.resultHygieneRevenueCurrent - this.resultHygieneSuppliesCurrent - this.resultAssociateWagesCurrent;
        this.resultGrossProfitCalculated = this.resultHygieneRevenueCalculated - this.resultHygieneSuppliesCalculated - this.resultAssociateWagesCalculated;

        /*Total Eligible Lead Profit Sharing*/
        this.resultEligibleProfitSharingCurrent = this.resultGrossProfitCurrent * this.resultProfitSharingCurrent/100;
        this.resultEligibleProfitSharingCalculated = this.resultGrossProfitCalculated * this.resultProfitSharingCalculated/100;
        /*Lead Monthly Wages Paid*/
         this.resultLeadWagesCurrent = this.txtHourlyRateAssociateCurrent * this.txtHoursWorkedPerDayCurrent * this.txtDaysWorkedPerWeekCurrent * 4.4;
        this.resultLeadWagesCalculated = this.txtHourlyRateAssociateCalculated * this.txtHoursWorkedPerDayCalculated * this.txtDaysWorkedPerWeekCalculated * 4.4;
        /*Hygienist Monthly Wage*/
        this.resultHygienistWageAmountCurrent = parseFloat(this.txtHourlyRateCurrent) * this.txtHoursWorkedPerDayCurrent * this.txtDaysWorkedPerWeekCurrent * 4.4;
        this.resultHygienistWageAmountCalculated = parseFloat(this.txtHourlyRateCalculated) * this.txtHoursWorkedPerDayCalculated * this.txtDaysWorkedPerWeekCalculated * 4.4;
        /*Lead Earned Monthly Incentive*/
        if(this.resultHygienistWageAmountCurrent > this.resultEligibleProfitSharingCurrent){ this.resultLeadEarnedIncentiveCurrent = 0;}
        else{this.resultLeadEarnedIncentiveCurrent = this.resultEligibleProfitSharingCurrent - this.resultHygienistWageAmountCurrent}
        if(this.resultHygienistWageAmountCalculated > this.resultEligibleProfitSharingCalculated){ this.resultLeadEarnedIncentiveCalculated = 0;}
        else{this.resultLeadEarnedIncentiveCalculated = this.resultEligibleProfitSharingCalculated - this.resultHygienistWageAmountCalculated}
        /*this.resultTotalHygienistEarnings = this.resultHygienistWageAmount + this.resultLeadEarnedIncentive;*/
        /*Lead Effective Hourly Rate*/
        this.resultLeadEarnedIncentiveleadHourlyRateWithIncentiveCurrent = Number(this.txtHourlyRateCurrent) + (this.resultLeadEarnedIncentiveCurrent/(this.txtHoursWorkedPerDayCurrent*this.txtDaysWorkedPerWeekAssociateCurrent * 4.4));
        this.resultLeadEarnedIncentiveleadHourlyRateWithIncentiveCalculated = Number(this.txtHourlyRateCurrent) + (this.resultLeadEarnedIncentiveCalculated/(this.txtHoursWorkedPerDayCalculated*this.txtDaysWorkedPerWeekAssociateCalculated * 4.4));
        /*Hourly Incentive*/
        this.resultHourlyIncentiveCurrent = (this.resultLeadEarnedIncentiveCurrent/(this.txtHoursWorkedPerDayCurrent*this.txtDaysWorkedPerWeekCurrent*4.4))
        this.resultHourlyIncentiveCalculated = (this.resultLeadEarnedIncentiveCalculated/(this.txtHoursWorkedPerDayCalculated*this.txtDaysWorkedPerWeekCalculated*4.4))
        /*Hourly Rate With Incentive*/
        this.resultHourlyRateWithIncentiveCurrent = Number(this.txtHourlyRateCurrent) + Number(this.resultHourlyIncentiveCurrent);
        console.log((this.txtHourlyRateCurrent) + " " +  this.resultHourlyIncentiveCurrent);
        this.resultHourlyRateWithIncentiveCalculated = parseFloat(this.txtHourlyRateCalculated) + this.resultHourlyIncentiveCalculated;
        /*Total Hygienist Earnings*/
        this.resultTotalHygienistEarningsCurrent = (this.resultHygienistWageAmountCurrent + this.resultLeadEarnedIncentiveCurrent) * 12;
        this.resultTotalHygienistEarningsCalculated = (this.resultHygienistWageAmountCalculated + this.resultLeadEarnedIncentiveCalculated) * 12;


        this.resultAssociateRevenueCurrent = this.numProductionPerDayAssociateCurrent * this.txtDaysWorkedPerWeekAssociateCurrent * 4.4;
        this.resultAssociateRevenueCalculated = this.numProductionPerDayAssociateCalculated * this.txtDaysWorkedPerWeekAssociateCalculated* 4.4;
        this.resultAssociateProfitSharingCurrent = 3;
        this.resultAssociateProfitSharingCalculated = 3;
        this.resultAssociateEarnedIncentiveCurrent = this.resultAssociateRevenueCurrent * this.resultAssociateProfitSharingCurrent/100;
        this.resultAssociateEarnedIncentiveCalculated = this.resultAssociateRevenueCalculated * this.resultAssociateProfitSharingCalculated/100;
        this.resultAssociateHourlyRateWithIncentiveCurrent = Number(this.txtHourlyRateAssociateCurrent) + (this.resultAssociateEarnedIncentiveCurrent/(this.txtHoursWorkedPerDayAssociateCurrent*this.txtDaysWorkedPerWeekAssociateCurrent*4.4));
        this.resultAssociateHourlyRateWithIncentiveCalculated = Number(this.txtHourlyRateAssociateCalculated) + (this.resultAssociateEarnedIncentiveCalculated/(this.txtHoursWorkedPerDayAssociateCalculated*this.txtDaysWorkedPerWeekAssociateCalculated*4.4));
        this.resultAssociateTotalEarningsCurrent = (this.resultAssociateWagesCurrent + this.resultAssociateEarnedIncentiveCurrent) * 12;
        this.resultAssociateTotalEarningsCalculated = (this.resultAssociateWagesCalculated + this.resultAssociateEarnedIncentiveCalculated) * 12;



        /*Format numbers for display*/
        this.resultHygieneRevenueCurrentFormatted = this.roundAndFormat(this.resultHygieneRevenueCurrent);
        this.resultHygieneRevenueCalculatedFormatted = this.roundAndFormat(this.resultHygieneRevenueCalculated);
        this.resultHygieneSuppliesCurrentFormatted = this.roundAndFormat(this.resultHygieneSuppliesCurrent);
        this.resultHygieneSuppliesCalculatedFormatted = this.roundAndFormat(this.resultHygieneSuppliesCalculated);
        this.resultAssociateWagesCurrentFormatted = this.roundAndFormat(this.resultAssociateWagesCurrent);
        this.resultAssociateWagesCalculatedFormatted = this.roundAndFormat(this.resultAssociateWagesCalculated);
        this.resultGrossProfitCurrentFormatted = this.roundAndFormat(this.resultGrossProfitCurrent);
        this.resultGrossProfitCalculatedFormatted = this.roundAndFormat(this.resultGrossProfitCalculated);
        this.resultProfitSharingCurrentFormatted = this.roundAndFormat(this.resultProfitSharingCurrent);
        this.resultProfitSharingCalculatedFormatted = this.roundAndFormat(this.resultProfitSharingCalculated);
        this.resultEligibleProfitSharingCurrentFormatted = this.roundAndFormat(this.resultEligibleProfitSharingCurrent);
        this.resultEligibleProfitSharingCalculatedFormatted = this.roundAndFormat(this.resultEligibleProfitSharingCalculated);
        this.resultLeadWagesCurrentFormatted = this.roundAndFormat(this.resultLeadWagesCurrent);
        this.resultLeadWagesCalculatedFormatted = this.roundAndFormat(this.resultLeadWagesCalculated);
        this.resultHygienistWageAmountCurrentFormatted = this.roundAndFormat(this.resultHygienistWageAmountCurrent);
        this.resultHygienistWageAmountCalculatedFormatted = this.roundAndFormat(this.resultHygienistWageAmountCalculated);
        this.resultLeadEarnedIncentiveCurrentFormatted = this.roundAndFormat(this.resultLeadEarnedIncentiveCurrent);
        this.resultLeadEarnedIncentiveCalculatedFormatted = this.roundAndFormat(this.resultLeadEarnedIncentiveCalculated);
        this.resultLeadHourlyRateWithIncentiveCurrentFormatted = this.roundAndFormat(this.resultLeadEarnedIncentiveleadHourlyRateWithIncentiveCurrent);
        this.resultLeadHourlyRateWithIncentiveCalculatedFormatted = this.roundAndFormat(this.resultLeadEarnedIncentiveleadHourlyRateWithIncentiveCalculated);
        this.resultHourlyRateWithIncentiveCurrentFormatted = this.currencyFormat(this.resultHourlyRateWithIncentiveCurrent).substring(1);
        this.resultHourlyRateWithIncentiveCalculatedFormatted = this.currencyFormat(this.resultHourlyRateWithIncentiveCalculated).substring(1);
        this.resultTotalHygienistEarningsCurrentFormatted = this.roundAndFormat(this.resultTotalHygienistEarningsCurrent);
        this.resultTotalHygienistEarningsCalculatedFormatted = this.roundAndFormat(this.resultTotalHygienistEarningsCalculated);

        this.resultAssociateRevenueCurrentFormatted = this.roundAndFormat(this.resultAssociateRevenueCurrent);
        this.resultAssociateRevenueCalculatedFormatted = this.roundAndFormat(this.resultAssociateRevenueCalculated);
        this.resultAssociateProfitSharingCurrentFormatted = this.roundAndFormat(this.resultAssociateProfitSharingCurrent);
        this.resultAssociateProfitSharingCalculatedFormatted = this.roundAndFormat(this.resultAssociateProfitSharingCalculated);
        this.resultAssociateEarnedIncentiveCurrentFormatted = this.roundAndFormat(this.resultAssociateEarnedIncentiveCurrent);
        this.resultAssociateEarnedIncentiveCalculatedFormatted = this.roundAndFormat(this.resultAssociateEarnedIncentiveCalculated);
       // this.resultLeadHourlyRateWithIncentiveCurrentFormatted = this.roundAndFormat(this.resultLeadHourlyRateWithIncentiveCurrent);
        //this.resultLeadHourlyRateWithIncentiveCalculatedFormatted = this.roundAndFormat(this.resultLeadHourlyRateWithIncentiveCalculated);
        this.resultAssociateEffectiveHourlyRateCurrentFormatted = this.roundAndFormat(this.resultAssociateEffectiveHourlyRateCurrent);
        this.resultAssociateEffectiveHourlyRateCalculatedFormatted = this.roundAndFormat(this.resultAssociateEffectiveHourlyRateCalculated);
        this.resultAssociateTotalEarningsCurrentFormatted = this.roundAndFormat(this.resultAssociateTotalEarningsCurrent);
        this.resultAssociateTotalEarningsCalculatedFormatted = this.roundAndFormat(this.resultAssociateTotalEarningsCalculated);
      },
      roundAndFormat(number) {
        var result = Math.round(number);
        result = result.toLocaleString();
        return result;
      },
      currencyFormat(number){
        var currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);
        return currency;
      },
      reset(){
        this.planType = 'Standard';
        this.txtProductionPerDayCurrent = "1,900";
        this.txtProductionPerDayCalculated = "1,900";
        this.txtHourlyRateCurrent = 40;
        this.txtHourlyRateCalculated = 40;
        this.txtHoursWorkedPerDayCurrent = 8;
        this.txtHoursWorkedPerDayCalculated = 8;
        this.txtDaysWorkedPerWeekCurrent = 4;
        this.txtDaysWorkedPerWeekIncremental = 4;
        this.txtPatientLoyaltyScoreCurrent = 55;
        this.txtPatientLoyaltyScoreCalculated = 55;
        this.resultHygieneRevenueCurrent = null;
        this.resultHygieneRevenueCalculated = null;
        this.resultHygieneRevenueIncremental = null;
        this.resultHygieneSuppliesCurrent = null;
        this.resultHygieneSuppliesCalculated = null;
        this.resultHygieneSuppliesIncremental = null;
        this.resultGrossProfitCurrent  = null;
        this.resultGrossProfitCalculated  = null;
        this.resultGrossProfitIncremental  = null;
        this.resultEligibleProfitSharingCurrent = null;
        this.resultEligibleProfitSharingCalculated = null;
        this.resultProfitSharing = 16;
        this.resultEligibleProfitSharing = 16;
        this.resultHygienistWageAmount = null;
        this.resultLeadEarnedIncentive = null;
        this.resultTotalHygienistEarnings = null;
        this.resultHourlyIncentive = null;
        this.resultHourlyRateWithIncentive = null;
        this.resultTotalHygienistEarnings = null;
        this.updateFields();
      },/*
          showCaptureRef() {
      console.log("this.$refs.capture: " + this.$refs.capture);
      let vc = this;
      return vc.$refs.capture;
    },*/
      getScreenShot(){
        //ar element = document.getElementById("calculator-wrapper");
        /*html2canvas(element, {
          onrendered: function(canvas) {
          var dataURL = canvas.toDataURL();
          //generated dataURL is now placed as src of a img tag
          document.getElementById('screenshot').src = dataURL;
        }
        });
        html2canvas(element, {
          onrendered: function(canvas) {
            var img = canvas.toDataURL()
            window.open(img);
          }
        });*/
      // alert("Descargando reporte visual")
      console.log('rendering screenshot');
      html2canvas(document.body).then(canvas => {
          document.body.appendChild(canvas)
      }).catch((error) => {
        console.log("Error: ", error)
      });





      }
    },

    data: () => ({
      planType: 'Standard',
      txtProductionPerDayCurrent: "1,500",
      txtProductionPerDayCalculated: "1,500",
      txtHourlyRateCurrent: "38.80",
      txtHourlyRateCalculated: "38.80",
      txtHoursWorkedPerDayCurrent: 8,
      txtHoursWorkedPerDayCalculated: 8,
      txtDaysWorkedPerWeekCurrent: 4,
      txtDaysWorkedPerWeekCalculated: 4,
      txtPatientLoyaltyScoreCurrent: 55,
      txtPatientLoyaltyScoreCalculated: 55,
      resultHygieneRevenueCurrent: null,
      resultHygieneRevenueCalculated: null,
      resultHygieneRevenueIncremental: null,
      resultHygieneSuppliesCurrent: null,
      resultHygieneSuppliesCalculated: null,
      resultHygieneSuppliesIncremental: null,
      resultAssociateWagesCurrent: null,
      resultAssociateWagesCalculated: null,
      resultLeadWagesCurrent: null,
      resultLeadWagesCalculated: null,
      resultGrossProfitCurrent: null,
      resultGrossProfitCalculated: null,
      resultGrossProfitIncremental: null,
      resultHygieneSupplies: null,
      resultGrossProfit : null,
      resultProfitSharingCurrent: 16,
      resultProfitSharingCalculated: 16,
      resultEligibleProfitSharing: null,
      resultHygienistWageAmount: null,
      resultHourlyIncentive: null,
      resultLeadEarnedIncentive: null,
      resultTotalHygienistEarnings: null,


      /*Associate Hygienist data */
      txtProductionPerDayAssociateCurrent: "1,800",
      txtProductionPerDayAssociateCalculated: "1,800",
      txtHourlyRateAssociateCurrent: "36.90",
      txtHourlyRateAssociateCalculated: "36.90",
      txtHoursWorkedPerDayAssociateCurrent: 8,
      txtHoursWorkedPerDayAssociateCalculated: 8,
      txtDaysWorkedPerWeekAssociateCurrent: 4,
      txtDaysWorkedPerWeekAssociateCalculated: 4,

      resultAssociateProfitSharingCurrent: null,
      resultAssociateProfitSharingCalculated: null,
      resultAssociateHourlyRateWithIncentiveCurrent: null,
      resultAssociateHourlyRateWithIncentiveCalculated: null,
      resultTotalAssociateEarningsCurrent: null,
      resultTotalAssociateEarningsCalculated: null,

      resultAssociateRevenueCurrent: null,
      resultAssociateRevenueCalculated: null,
      resultAsssociateProfitSharingCurrent: null,
      resultAsssociateProfitSharingCalculated: null,
      resultAssociateEarnedIncentiveCurrent: null,
      resultAssociateEarnedIncentiveCalculated: null,
      resultLeadHourlyRateWithIncentiveCurrent: null,
      resultLeadHourlyRateWithIncentiveCalculated: null,
      resultAssociateEffectiveHourlyRateCurrent: null,
      resultAssociateEffectiveHourlyRateCalculated: null,
      resultAssociateTotalEarningsCurrent: null,
      resultAssociateTotalEarningsCalculated: null,
      resultEligibleProfitSharingCurrent: null,
      resultEligibleProfitSharingCalculated: null,


      /*Formateted for display*/
      resultHygieneRevenueCurrentFormatted: null,
      resultHygieneRevenueCalculatedFormatted: null,
      resultHygieneRevenueIncrementalFormatted: null,
      resultHygieneSuppliesCurrentFormatted: null,
      resultHygieneSuppliesCalculatedFormatted: null,
      resultHygieneSuppliesIncrementalFormatted: null,
      resultAssociateWagesCurrentFormatted: null,
      resultAssociateWagesCalculatedFormatted: null,
      resultGrossProfitCurrentFormatted: null,
      resultGrossProfitCalculatedFormatted: null,
      resultProfitSharingCurrentFormatted: null,
      resultProfitSharingCalculatedFormatted: null,
      resultEligibleProfitSharingCurrentFormatted: null,
      resultEligibleProfitSharingCalculatedFormatted: null,
      resultLeadWagesCurrentFormatted: null,
      resultLeadWagesCalculatedFormatted: null,
      resultHygienistWageAmountCurrentFormatted: null,
      resultHygienistWageAmountCalculatedFormatted: null,
      resultLeadEarnedIncentiveCurrentFormatted: null,
      resultLeadEarnedIncentiveCalculatedFormatted: null,
      resultLeadHourlyRateWithIncentiveCurrentFormatted: null,
      resultLeadHourlyRateWithIncentiveCalculatedFormatted: null,
      resultHourlyRateWithIncentiveCurrentFormatted: null,
      resultHourlyRateWithIncentiveCalculatedFormatted: null,
      resultTotalHygienistEarningsCurrentFormatted: null,
      resultTotalHygienistEarningscalculatedFormatted: null,

      tipProductionPerDay: "<p><strong>Production Per Day</strong></p>Average net production charged out per day worked by Hygienists. This averages when there are multiple Hygienists working, it does not add them together. This is impacted by adjustments for patients previously seen by current providers in the same location.",
      tipHourlyRate: "<p><strong>Hourly Rate</strong></p>The hourly rate the Hygienist is paid.",
      tipHoursWorkedPerDay: "<p><strong>Hours Worked Per Day</strong></p>Total hours worked by the Hygienist per day.",
      tipDaysWorkedPerWeek: "<p><strong>Days Worked Per Week</strong></p>Total days worked by the Hygienist per week.",
      tipPatientLoyaltyScore: "<p><strong> Patient Net Promoter Score (NPS) </strong></p>Patient Satisfaction measured by Patient NPS (90 Day) – see Patient Experience Survey Dashboard.",
      tipMCDProfitSharePercent: "<p><strong>MCD Profit Share Percent</strong></p>The profit sharing % that the MCD in the office is eligible to receive.",
      tipHygieneRevenue: "<p><strong>Hygiene Revenue</strong></p>Net revenue charged out for work performed by Hygienists. This can be impacted by adjustments for patients seen previously.  Assume 4.4 weeks worked per month.",
      tipHygieneSupplies: "<p><strong>Hygiene Supplies</strong></p>Hygiene supplies purchased in the month.",
      tipAssociateWages: "<p>Associate Wages</p>Associate hygienist wages for the month. Includes all paid hours.",
      tipGrossProfit : "<p><strong>Gross Profit</strong></p>Hygiene revenue minus Hygiene supplies.",
      tipProfitSharing: "<p><strong>Profit Sharing %</strong></p>Eligible Hygienist profit sharing % based on  Patient Net Promoter Score (NPS) ",
      tipEligibleProfitSharing: "<p><strong>Total Eligible Lead Profit Sharing (Total Hygienist Earnings)</strong></p>Gross Profit multiplied by the Profit Sharing %",
      tipLeadWages: "<p><strong>Lead Monthly Wages Paid</strong>Lead hygienist wages for the month. Includes all paid hours.",
      tipHygienistWageAmount: "<p><strong>Hygienist Monthly Wages Paid</strong></p>Hygienist wages for the month. Includes all paid hours.  Assume 4.4 weeks worked per month.",
      tipHygienistEarnedIncentive: "<p><strong>Lead Earned Monthly Incentive</strong></p>Eligible Profit Sharing minus Lead Monthly Wages Paid.",
      tipLeadHourlyRateWithIncentive:"<p><strong>Lead Effective Hourly Rate</strong></p>Lead Hygienist hourly rate with base pay plus earned incentive",
      tipTotalHygienistEarnings:  "<p><strong>Total Hygienist Earnings</strong></p>Hygienist wages plus earned incentive.",
      tipHourlyRateWithIncentive: "<p><strong> Lead Effective Hourly Rate</strong></p>Lead Hygienist hourly rate with base pay plus earned incentive.",
      tipTotalHygienestEarnings: "<p><strong>Total Lead Annual Earnings</strong></p>Lead Monthly Wages Paid plus earned incentive.",
      tipAssociateRevenue: "<p><strong>Associate Revenue</strong></p> Net revenue charged out for work performed by the Associate Hygienist. This can be impacted by adjustments for patients seen previously.",
      tipAssocaiteProfitSharing: "<p><strong>Associate Profit Sharing %</strong></p> Eligible associate profit sharing.",
      tipAssociateEarnedIncentive: "<p><strong>Associate Earned Monthly Incentive</strong></p> Associate revenue multiplied by 3% profit sharing.",
      tipAssociateHourlyRateWithIncentive: "<p><strong>Associate Effective Hourly Rate</strong></p>Associate Hygienist hourly rate with base pay plus earned incentive",
      tipTotalAssociateEarings: "<p><strong>Total Associate Annual Earnings</strong></p> Associate wages plus earned incentive.",
    }),
    watch: {
      txtProductionPerDayCurrent: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtProductionPerDayCurrent = result);
      },
      txtProductionPerDayCalculated: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtProductionPerDayCalculated = result);
      },
      txtProductionPerDayAssociateCurrent: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtProductionPerDayAssociateCurrent = result);
      },
      txtProductionPerDayAssociateCalculated: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtProductionPerDayAssociateCalculated = result);
      },
    },
    created(){
      this.updateFields();
    },
  }
</script>
